import React from 'react';
import { withRouter } from 'react-router-dom';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.redirectToError = this.redirectToError.bind(this);
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo);
  }

  redirectToError() {
    const { error } = this.state;
    const { history } = this.props;
    history.push('/error', {
      ui: true,
      error,
    });
    this.setState({ hasError: false });
  }

  render() {
    const { hasError } = this.state;
    if (hasError) {
      // You can render any custom fallback UI
      this.redirectToError();
      return null;
    }

    return this.props.children;
  }
}
export default withRouter(ErrorBoundary);
